module.exports = __webpack_public_path__ + "img/haval_thumbnail.8540676f.png";